module.exports = __webpack_public_path__ + "img/undraw_done_re_oak4.452cc5c3.svg";